import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Page } from '@components/page';
import { Card, Center } from '@styles/components/wrapper';
import { LeftOutlined } from '@ant-design/icons';
import { useQuery } from '@hooks/use-query';
import {
    fetchAllAvailablePlatforms,
    fetchAvailableTypes,
    resetSelectItemsState,
} from '@redux/slices/order';
import { translate } from '@components/i18n';
import { CardHeader } from '../components/card-header';
import { SelectTypeForm } from './components/select-type-form';
import { fetchMoneySymbols, fetchMoneyTypes, moneyTypeSelector } from '@redux/slices/money-type';


export const SelectType: React.FC = () => {
    const dispatch = useDispatch();
    const query = useQuery();

    const moneyType = useSelector(moneyTypeSelector)

    const isDraft = query.get("draft")

    useEffect(() => {
        if (!isDraft) {
            dispatch(resetSelectItemsState());
        } else {
            dispatch(fetchAvailableTypes());
        }

        if (!moneyType?.isSuccessSymbols) {
            dispatch(fetchMoneySymbols())
        }
        if (!moneyType?.isSuccess) {
            dispatch(fetchMoneyTypes());
        }
        dispatch(fetchAllAvailablePlatforms())
    }, []);

    return (
        <Page
            title={translate('pages.newOrder')}
            greyBackground
            onClickGoBack
            menuIcon={<LeftOutlined />}
        >
            <Center>
                <Card title={<CardHeader />} padding={'24px 15%'}>
                    <SelectTypeForm />
                </Card>
            </Center>
        </Page>
    );
};
